
<style scoped lang="scss">
  // @import '~@/assets/styles/vars';

  .list-wrapper {
    width: 100%;
    padding: 8px;
    display: flex;
    justify-content: center;
  }
  .list-item {
    cursor: pointer;
    flex-wrap: wrap;
    // display: inline-block;
    margin-right: 4px;
  }
</style>

<template>
  <ul class="list-wrapper">
    <li class="list-item" v-for="(item, index) in projectListData"
      :key="item.id"
      @click="onClick(item.music, item.project)"
    >
      <music-jacket
        :imgSrc="item.jacket"
        :projectSrc="item.project"
      ></music-jacket>
    </li>
  </ul>
</template>

<script>
import musicJacket from '@/components/sub/musicJacket';

/**
 * clickでParentにわたす
 */
export default {
  name: 'musicList',
  components: {
    musicJacket,
  },
  props: {
    projectListData: Array,
  },

  methods: {
    onClick: function(musicSrc, projectSrc) {
      this.$emit('click', musicSrc, projectSrc);
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/MusicList.vue